import React, { Component } from "react";
import { connect } from "react-redux";
import { cargarDocumentoAction } from "./inputFileUpperActions";
import "./InputFiles.css";
import TagManagerUtils from '../../../utils/TagManagerUtils';
import { obtenerNombreMeses, getMonthNow } from "../../../utils/FormatUtil";
import waitToUp from "../../assets/svg/icon-subir_doc.svg";
import upAgain from "../../assets/svg/icon-volver_adjuntar.svg";
import imgEye from "../../assets/svg/icon-revisar_doc.svg";
import VisorPDF from "../visor/VisorPDF";
import Alert from "../alert/alert";
import iconFile1 from "../../assets/svg/icon-subir.svg";
import iconFile2 from "../../assets/svg/icon-adjuntando1.svg";
import iconFile3 from "../../assets/svg/icon-listo.svg";


class InputFileUpper extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      iconStatusUpload: "",
      spinner: "",
      isDisabled: false,
      disableFile: false,
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOpenVisor = this.handleOpenVisor.bind(this);
    this.handleCloseVisor = this.handleCloseVisor.bind(this);
  }

  handleOnclick = (inputMes) => {
    const { inputName, estado, wv } = this.props;
    if (estado === "Adjuntar") {
      TagManagerUtils.globalTag({
        'event': 'eve',
        'eve-acc': inputMes? `${inputName}${obtenerNombreMeses(getMonthNow(inputMes))}`:inputName,
        'eve-cat': 'Click credito distancia',
        'eve-lab': 'Adjuntar',
        'ambiente': wv ? 'app':'sitio'
      })
    } else if (estado === "Volver a adjuntar") {
      TagManagerUtils.globalTag({
        'event': 'eve',
        'eve-acc': inputMes? `${inputName}${obtenerNombreMeses(getMonthNow(inputMes))}`:inputName,
        'eve-cat': 'Click credito distancia',
        'eve-lab': 'Volver a adjuntar',
        'ambiente': wv ? 'app':'sitio'
      })

    }

  }

  /* handleOnChangeX = (event) => {
    const srcSelect = event.target.files[0];

    const jsonFile = new FormData();
    jsonFile.append('file', event.target.files[0]);
    jsonFile.append('name', event.target.files[0].name);
    console.log(jsonFile.file)

    if (srcSelect) {
      // const nameFile = srcSelect.name.split('.').slice(0, -1).join('.');
      const extension = srcSelect.name.split('.').pop();
      // const sizeFile = srcSelect.size;
      // const maxSize = 5000000;
      const urlImg = URL.createObjectURL(srcSelect);
      let fileBase64 = "";
      const reader = new FileReader();
      const aux = reader.readAsDataURL(srcSelect);

      reader.onload = function () {
        fileBase64 = reader.result.split(',')[reader.result.split(',').length - 1];
        const { cargarDocumento, nItems } = this.props;
        cargarDocumento(fileBase64, nItems, srcSelect.name, srcSelect.size, urlImg, extension);
        const { eventChange } = this.props;
        eventChange();
      }.bind(this);

      reader.onerror = function (error) {
        console.log('Error: ', error);
        console.log('EXIT: ', aux);
      };
    }


  }; */

  handleOpenVisor = (inputMes) => {
    const { disableFile } = this.state;
    this.setState({
      disableFile: !disableFile
    });
    // TAG
    const { inputName, wv } = this.props;
    TagManagerUtils.globalTag({
      'event': 'eve',
      'eve-acc': inputMes? `${inputName}${obtenerNombreMeses(getMonthNow(inputMes))}`:inputName,
      'eve-cat': 'Click credito distancia',
      'eve-lab': 'Revisar documento',
      'ambiente': wv ? 'app':'sitio'
    })

  };

  handleCloseVisor = () => {
    const { disableFile } = this.state;
    this.setState({
      disableFile: !disableFile
    });
  };

  handleOnChange = (event) => {
    const selectedFile = event.target.files;
    let file = null;
    let fileName = "";
    let extension;
    let urlImg;
    let size;
    // Check si existe algo cargado
    if (selectedFile.length > 0) {
      // seleciono el archivo entrante y defino las variables entorno a el
      const fileToLoad = selectedFile[0];
      fileName = fileToLoad.name;
      extension = fileToLoad.name.split('.').pop();
      urlImg = URL.createObjectURL(fileToLoad);
      size = fileToLoad? fileToLoad.size:0;
      // instancio la lectura del archivo.
      const fileReader = new FileReader();
      // tomo los metodos a utilizar
      const { cargarDocumento, nItems } = this.props;
      const { eventChange } = this.props;
      // subo el archivo al contendor
      fileReader.onload =  (fileLoadedEvent) => {
        file = fileLoadedEvent.target.result;
        // proceso el archivo
        const fileBase64 = file.split(',')[file.split(',').length - 1];
        cargarDocumento(fileBase64, nItems, fileName, size, urlImg, extension);
        eventChange();
      };
      // Convert data to base64
      fileReader.readAsDataURL(fileToLoad);
    }

  }

  render() {
    const {
      iconStatusUpload,
      spinner,
      isDisabled,
      disableFile,
    } = this.state;
    const {
      htmlForTag,
      nItems,
      inputMes,
      inputName,
      estado,
      file,
      errors,
      url,
      visorPDF
    } = this.props;
    return (
      <>
        <div className="col-md-8 row no_right_padding">
          <div className="col-2 d-flex justify-content-center align-items-center ">
            {file !== null ? (
              <div>
                <img
                  src={estado === "Adjuntando" ? iconFile2 : iconFile3}
                  className="iconFile"
                  alt="svg"
                />
              </div>
            )
              : (
                <div>
                  <img src={iconFile1} className="iconFile" alt="svg" />
                </div>
              )}
          </div>
          <div className="inputFileA col-10 no_padding">
            <div>
              {file === null && (
                <div className="box_name">
                  <span className="textoU_Reg13">Adjunta documento de tu </span>
                  <span className="docName textoU_Med13">
                    <strong>
                      {inputName}
                      <span>
                        {inputMes !== undefined && (<span>{`(${obtenerNombreMeses(getMonthNow(inputMes))})`}</span>)}
                      </span>
                    </strong>
                  </span>
                </div>
              )}
            </div>
            <div className="docName docNameC textoU_Med13">
              {file !== null ? (
                <>
                  <strong>
                    {inputName}
                    <span>
                      {inputMes !== undefined && (<span>{`(${obtenerNombreMeses(getMonthNow(inputMes))})`}</span>)}
                    </span>
                  </strong>
                  <span className="textoU_Reg13 ml-1"> adjuntada</span>
                </>
              ) : null}
            </div>
          </div>
        </div>

        <div className="col-md-4 pad0">
          <div className="inputFileB">
            <div className="visorFile " />
            <VisorPDF visorPDF={visorPDF} setFile={url} disableFile={disableFile} close={this.handleCloseVisor} />
            {file !== null && (
              <button
                className="openModal"
                type="button"
                onClick={() => this.handleOpenVisor(inputMes)}
              >
                <img src={imgEye} className="icon_upper" alt="Revisar documento" />
                <div className="btnOpenText">Revisar documento</div>
              </button>
            )}

            <label htmlFor={htmlForTag + nItems}>
              <div className="cajaFile">
                {file === null && estado === "Adjuntar" && (
                  <img className={`${spinner} icon_upper`} src={waitToUp} alt="Esperando para cargar" />
                )}

                {file === null && estado === "Adjuntando" && (
                  <img className={`${spinner} icon_upper`} src={iconStatusUpload} alt="Cargando" />
                )}

                <div className="labelInputFile">
                  {file ? (
                    <div className="up_Again">
                      <img src={upAgain} className="icon_upper" alt="Volver a adjuntar" />
                      {estado}
                    </div>
                  ) : (
                      estado
                    )}
                </div>
              </div>

              <input
                id={htmlForTag + nItems}
                name={htmlForTag + nItems}
                type="file"
                onChange={this.handleOnChange}
                onClick={() => this.handleOnclick(inputMes)}
                disabled={!!isDisabled}
              />
            </label>
          </div>
        </div>
        {
          errors
          && (
            <div className="col-12 conterAler">
              <Alert mensaje={errors} tipo="alert-danger" icons="iconAlertDanger" />
            </div>
          )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    checkoutInputFiles: [false, false, false, false, false],
    wv: state.webViuw.estado
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cargarDocumento: (file, id, fileType, fileSize, url, extension) => dispatch(cargarDocumentoAction(file, id, fileType, fileSize, url, extension))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InputFileUpper);